<div class="min-h-full" style="background-color: #fafaf7;">
  <div class="max-w-[800px] mx-auto px-5 sm:px-8 py-8 space-y-6">

    <!-- Header -->
    <div class="fiche-titlebar grid grid-cols-3 items-center pt-4 px-2">
      <div class="justify-self-start">
        <button (click)="onCancel()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux albums</span>
        </button>
      </div>
      <div class="justify-self-center">
        <h1 class="page-title">Nouvel album</h1>
      </div>
      <div class="justify-self-end"></div>
    </div>

    @if (errorMessage()) {
      <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <span class="material-icons text-base text-red-500">error_outline</span>
        {{ errorMessage() }}
      </div>
    }

    <form (ngSubmit)="onSave()" class="space-y-6">

      <!-- Infos -->
      <div class="fiche-section">
        <div class="fiche-section-title">Informations de l'album</div>
        <div class="fiche-section-box">
          <div class="fiche-grid">
            <div class="fiche-field">
              <span class="fiche-label-fixed">Titre <span class="text-red-500">*</span></span>
              <input type="text"
                [value]="title()"
                (input)="title.set($any($event.target).value)"
                placeholder="Titre de l'album"
                autoDir class="fiche-input" />
            </div>
            <div class="fiche-field">
              <span class="fiche-label-fixed">Date <span class="text-red-500">*</span></span>
              <input type="date"
                [value]="eventDate()"
                (input)="eventDate.set($any($event.target).value)"
                class="fiche-input" />
            </div>
            <div class="fiche-field">
              <span class="fiche-label-fixed">Tags</span>
              <app-tag-input module="MEDIA" [value]="category()" (valueChange)="category.set($event)"></app-tag-input>
            </div>
          </div>
        </div>
      </div>

      <!-- Média -->
      <div class="fiche-section">
        <div class="fiche-section-title">Média</div>
        <div class="fiche-section-box space-y-4">

          <!-- Media grid -->
          @if (mediaItems().length > 0) {
            <div class="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-3">
              @for (item of mediaItems(); track $index) {
                <div class="relative aspect-square rounded-xl overflow-hidden bg-stone-100 group">

                  @if (item.type === 'image') {
                    <img [src]="item.preview" alt="" class="w-full h-full object-cover" />
                  }

                  @if (item.type === 'video') {
                    @if (item.videoLink && videoThumbnail(item.videoLink)) {
                      <img [src]="videoThumbnail(item.videoLink)!" alt="" class="w-full h-full object-cover" />
                    } @else {
                      <div class="w-full h-full bg-stone-900 flex items-center justify-center">
                        <span class="material-icons text-stone-500 text-3xl">videocam</span>
                      </div>
                    }
                    <!-- Play overlay -->
                    <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div class="w-7 h-7 rounded-full bg-black/60 flex items-center justify-center">
                        <svg class="w-3.5 h-3.5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </div>
                    </div>
                  }

                  <!-- Type badge -->
                  <div class="absolute bottom-1 left-1">
                    @if (item.type === 'image') {
                      <span class="text-[9px] font-bold bg-black/50 text-white px-1.5 py-0.5 rounded-full">IMG</span>
                    } @else {
                      <span class="text-[9px] font-bold bg-red-500/80 text-white px-1.5 py-0.5 rounded-full">VID</span>
                    }
                  </div>

                  <!-- Remove button -->
                  <button type="button" (click)="removeMediaItem($index)"
                    class="absolute top-1 right-1 w-5 h-5 rounded-full bg-red-500 hover:bg-red-600 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow">
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                  </button>
                </div>
              }
            </div>
          }

          <!-- Add button -->
          <button type="button" (click)="openModal()"
            class="cursor-pointer inline-flex items-center gap-2 px-4 py-2 border-2 border-dashed border-stone-300 hover:border-primary-400 text-stone-500 hover:text-primary-600 rounded-xl transition-all text-sm font-medium">
            <span class="material-icons text-base">add</span>
            Ajouter média
          </button>

          <p class="text-xs text-stone-400">Images (JPG, WEBP · max 10 Mo) ou liens YouTube / Vimeo</p>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 pt-2">
        <button type="button" (click)="onCancel()" [disabled]="isLoading()"
          class="px-5 py-2.5 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors text-sm font-medium">
          Annuler
        </button>
        <button type="submit" [disabled]="isLoading()"
          class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-semibold shadow-sm">
          @if (isLoading()) {
            <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          } @else {
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          }
          {{ isLoading() ? 'Création…' : 'Créer l\'album' }}
        </button>
      </div>

    </form>
  </div>
</div>

<!-- Add Média Modal -->
@if (showModal()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4" style="background:rgba(0,0,0,0.4);" (click)="closeModal()">
    <div class="bg-white rounded-2xl shadow-xl w-full max-w-md" (click)="$event.stopPropagation()">

      <!-- Modal header -->
      <div class="flex items-center justify-between px-6 pt-5 pb-4 border-b border-stone-100">
        <h2 class="text-sm font-bold text-stone-800">Ajouter un média</h2>
        <button type="button" (click)="closeModal()" class="w-7 h-7 rounded-lg hover:bg-stone-100 flex items-center justify-center text-stone-400 transition-colors">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>

      <!-- Tabs -->
      <div class="flex border-b border-stone-100 px-6">
        <button type="button" (click)="modalTab.set('image')"
          class="py-3 px-4 text-xs font-semibold border-b-2 transition-colors"
          [class]="modalTab() === 'image' ? 'border-primary-600 text-primary-600' : 'border-transparent text-stone-400 hover:text-stone-600'">
          <span class="flex items-center gap-1.5">
            <span class="material-icons text-sm">image</span>
            Image
          </span>
        </button>
        <button type="button" (click)="modalTab.set('video')"
          class="py-3 px-4 text-xs font-semibold border-b-2 transition-colors"
          [class]="modalTab() === 'video' ? 'border-primary-600 text-primary-600' : 'border-transparent text-stone-400 hover:text-stone-600'">
          <span class="flex items-center gap-1.5">
            <svg class="w-3.5 h-3.5 text-red-500" fill="currentColor" viewBox="0 0 24 24">
              <path d="M21.582 6.186a2.506 2.506 0 00-1.765-1.77C18.254 4 12 4 12 4s-6.254 0-7.817.416A2.506 2.506 0 002.418 6.186 26.5 26.5 0 002 12a26.5 26.5 0 00.418 5.814 2.506 2.506 0 001.765 1.77C5.746 20 12 20 12 20s6.254 0 7.817-.416a2.506 2.506 0 001.765-1.77A26.5 26.5 0 0022 12a26.5 26.5 0 00-.418-5.814zM10 15.464V8.536L16 12l-6 3.464z"/>
            </svg>
            Vidéo
          </span>
        </button>
      </div>

      <!-- Modal body -->
      <div class="px-6 py-5 space-y-4">

        @if (modalTab() === 'image') {
          @if (modalFiles().length > 0) {
            <div class="grid grid-cols-3 gap-2 max-h-64 overflow-y-auto">
              @for (f of modalFiles(); track $index) {
                <div class="relative aspect-square rounded-xl overflow-hidden bg-stone-100">
                  @if (f.preview) {
                    <img [src]="f.preview" alt="" class="w-full h-full object-cover" />
                  } @else {
                    <div class="w-full h-full flex flex-col items-center justify-center gap-1 text-stone-400">
                      <span class="material-icons text-2xl">image</span>
                      <span class="text-[9px] font-semibold uppercase px-1 text-center break-all leading-tight">{{ f.file.name }}</span>
                    </div>
                  }
                  <button type="button" (click)="removeModalFile($index)"
                    class="absolute top-1 right-1 w-5 h-5 rounded-full bg-red-500 text-white flex items-center justify-center shadow">
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                  </button>
                </div>
              }
            </div>
            <p class="text-xs text-stone-500">{{ modalFiles().length }} image{{ modalFiles().length > 1 ? 's' : '' }} sélectionnée{{ modalFiles().length > 1 ? 's' : '' }}</p>
          }
          <label class="cursor-pointer flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-stone-300 hover:border-primary-400 transition-colors"
            [class]="modalFiles().length ? 'py-4' : 'py-10'">
            <span class="material-icons text-stone-300 text-4xl">add_photo_alternate</span>
            <span class="text-sm text-stone-400">
              @if (modalFiles().length) { Ajouter d'autres images } @else { Cliquez pour sélectionner une ou plusieurs images }
            </span>
            <span class="text-xs text-stone-300">JPG, WEBP · max 10 Mo par image</span>
            <input type="file" accept=".jpg,.jpeg,.webp" multiple class="hidden" (change)="onModalFileSelected($event)" />
          </label>
        }

        @if (modalTab() === 'video') {
          <div class="space-y-2">
            <label class="text-xs font-semibold text-stone-500">Lien YouTube ou Vimeo</label>
            <input type="url"
              [value]="modalVideoLink()"
              (input)="modalVideoLink.set($any($event.target).value)"
              placeholder="https://www.youtube.com/watch?v=..."
              class="fiche-input w-full" />
          </div>
        }

        @if (modalError()) {
          <p class="text-xs text-red-500">{{ modalError() }}</p>
        }

      </div>

      <!-- Modal footer -->
      <div class="flex items-center justify-end gap-3 px-6 pb-5">
        <button type="button" (click)="closeModal()"
          class="px-4 py-2 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 text-sm font-medium transition-colors">
          Annuler
        </button>
        <button type="button" (click)="confirmAdd()"
          class="px-5 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 text-sm font-semibold transition-colors">
          Ajouter
        </button>
      </div>

    </div>
  </div>
}
